export const difference = <A>(setA: Set<A>, setB: Set<A>): Set<A> => {
  const _difference = new Set(setA)

  for (const elem of setB) {
    _difference.delete(elem)
  }

  return _difference
}
